import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/HomeNew";
import ServicesPage from "./pages/ServicesNew";
import IndustriesPage from "./pages/IndustriesPage";
import OurWork from "./pages/OurWork";
import OurWorkDetail from "./pages/OurWorkDetail";
import PricingPage from "./pages/PricingPage";
import GetMyWebsite from "./pages/GetMyWebsite";
import ClientLogin from "./pages/ClientLogin";
import ClientDashboard from "./pages/ClientDashboard";
import PayMyBill from "./pages/PayMyBill";
import LegalPage from "./pages/LegalPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/what-we-can-build" element={<OurWork />} />
            <Route path="/what-we-can-build/:slug" element={<OurWorkDetail />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/get-started" element={<GetMyWebsite />} />
            <Route path="/client-login" element={<ClientLogin />} />
            <Route path="/client" element={<ClientDashboard />} />
            <Route path="/pay-my-bill" element={<PayMyBill />} />
            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
            <Route path="/terms" element={<LegalPage kind="terms" />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
